import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c30a87ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-layout" }
const _hoisted_2 = { class: "flex col g24" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "halftitle" }, "Secureat", -1))
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex col g0" }
const _hoisted_6 = { class: "bold f14" }
const _hoisted_7 = { class: "f12" }
const _hoisted_8 = { class: "flex align-center justify-center" }
const _hoisted_9 = {
  style: {"white-space":"nowrap"},
  class: "text-muted"
}
const _hoisted_10 = {
  style: {"line-break":"auto","width":"300px"},
  class: "text-red"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeDropdownItem = _resolveComponent("SeDropdownItem")!
  const _component_SeDropdown = _resolveComponent("SeDropdown")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_ReadonlyField = _resolveComponent("ReadonlyField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavHeader, {
      backButton: "true",
      title: _ctx.state.selectedStore!.name
    }, null, 8, ["title"]),
    _createVNode(_component_ReadonlyField, {
      locked: _ctx.role == _ctx.Role.Manager,
      class: "container"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_ctx.state.currentDatabase != null)
              ? _withDirectives((_openBlock(), _createBlock(_component_SeButton, {
                  key: 0,
                  onPress: _ctx.manageTasks,
                  icon: "/ico/databases.svg"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.Lang.getI18N("database")), 1),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.state.currentDatabase.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["onPress"])), [
                  [_vShow, _ctx.state.currentDatabase != null]
                ])
              : _createCommentVNode("", true),
            (_ctx.state.currentDatabase == null)
              ? (_openBlock(), _createBlock(_component_SeButton, {
                  key: 1,
                  onPress: _ctx.openDatabasesModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("store.select-database")), 1)
                  ]),
                  _: 1
                }, 8, ["onPress"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_SeModal, {
            ref: "databasesModal",
            title: _ctx.Lang.getI18N('database')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.Lang.getI18N("database")) + ": ", 1),
                _createVNode(_component_SeDropdown, {
                  titleFunc: (database) => database.name,
                  ref: "databaseSelect",
                  search: true,
                  modelValue: _ctx.state.selectedDatabase,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.selectedDatabase) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.databases, (database) => {
                      return (_openBlock(), _createBlock(_component_SeDropdownItem, {
                        key: database.ref?.id,
                        value: database
                      }, null, 8, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["titleFunc", "modelValue"])
              ]),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.dbError), 1),
              _createVNode(_component_SeButton, {
                onPress: _ctx.selectDatabase,
                class: "modal-valid center",
                style: {"width":"300px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Ok")
                ]),
                _: 1
              }, 8, ["onPress"])
            ]),
            _: 1
          }, 8, ["title"])
        ])
      ]),
      _: 1
    }, 8, ["locked"])
  ]))
}